import React from "react";
import { useTranslation } from "react-i18next";

const NotFound: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className="page-all">
      <div className="page-content page-content--center">
        <div className="container text-muted text-center text-huge text-w-medium">
          <p>{t("submit.err.notFound")}</p>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
